import { render, staticRenderFns } from "./UIChip.vue?vue&type=template&id=1430cb3f"
import script from "./UIChip.vue?vue&type=script&lang=js"
export * from "./UIChip.vue?vue&type=script&lang=js"
import style0 from "./UIChip.vue?vue&type=style&index=0&id=1430cb3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports